import { useState, useEffect } from 'react';
import BackButton from '../components/BackButton';
import api from '../api';
import { useI18n } from '../i18n/index.jsx';

export default function MyAnalytics() {
  const [stats, setStats] = useState(null);
  const { t } = useI18n();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  async function loadStats() {
    try {
      const res = await api.get('/analytics/my');
      setStats(res.data);
    } catch (e) {
      console.error('Failed to load stats:', e);
    } finally {
      setLoading(false);
    }
  }

  const StatCard = ({ icon, label, value, sub, color = '108,92,231' }) => (
    <div style={{
      background: `rgba(${color},0.15)`,
      borderRadius: 12,
      padding: 20,
      textAlign: 'center',
      flex: 1,
      minWidth: 120,
    }}>
      <div style={{ fontSize: 32 }}>{icon}</div>
      <div style={{ fontSize: 28, fontWeight: 700, marginTop: 8 }}>{value}</div>
      <div style={{ fontSize: 13, opacity: 0.7 }}>{label}</div>
      {sub && <div style={{ fontSize: 12, opacity: 0.5, marginTop: 4 }}>{sub}</div>}
    </div>
  );

  return (
    <div className="page">
      <BackButton />
      <h1>📈 Моя статистика</h1>

      {loading ? (
        <div className="loader">{t('common.loading')}</div>
      ) : stats ? (
        <>
          {/* Invoices */}
          <div style={{ marginBottom: 24 }}>
            <h3>📄 Фактуры</h3>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <StatCard 
                icon="📄" 
                label="Выставлено" 
                value={stats.invoices.count}
              />
              <StatCard 
                icon="💰" 
                label="Объём" 
                value={stats.invoices.total_pln.toLocaleString()}
                sub="PLN"
                color="0,206,201"
              />
            </div>
          </div>

          {/* Payouts */}
          <div style={{ marginBottom: 24 }}>
            <h3>💸 Выплаты</h3>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <StatCard 
                icon="✅" 
                label="Получено" 
                value={stats.payouts.total_pln.toLocaleString()}
                sub="PLN"
                color="0,206,201"
              />
              <StatCard 
                icon="⏳" 
                label="В ожидании" 
                value={stats.payouts.pending_pln.toLocaleString()}
                sub="PLN"
                color="255,193,7"
              />
              <StatCard 
                icon="📊" 
                label="Всего выплат" 
                value={stats.payouts.count}
              />
            </div>
          </div>

          {/* Contracts */}
          <div style={{ marginBottom: 24 }}>
            <h3>📝 Контракты</h3>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <StatCard 
                icon="🚀" 
                label="Gateway" 
                value={stats.contracts.gateway}
                color="108,92,231"
              />
              <StatCard 
                icon="📋" 
                label="Work" 
                value={stats.contracts.work}
                color="108,92,231"
              />
            </div>
          </div>

          {/* Summary */}
          <div style={{
            background: 'linear-gradient(135deg, rgba(0,206,201,0.2), rgba(108,92,231,0.2))',
            borderRadius: 16,
            padding: 24,
            textAlign: 'center',
          }}>
            <div style={{ fontSize: 14, opacity: 0.7 }}>Общий оборот</div>
            <div style={{ fontSize: 36, fontWeight: 700, color: '#00cec9' }}>
              {stats.invoices.total_pln.toLocaleString()} PLN
            </div>
            <div style={{ fontSize: 13, opacity: 0.6, marginTop: 8 }}>
              Комиссия 6%: ~{(stats.payouts.total_pln * 0.06).toLocaleString()} PLN
            </div>
          </div>
        </>
      ) : (
        <div style={{ textAlign: 'center', padding: 40, opacity: 0.6 }}>
          <div style={{ fontSize: 48 }}>📊</div>
          <p>{t('my_analytics.no_data')}</p>
        </div>
      )}
    </div>
  );
}
